import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetTagServicoTomadoResponse } from '../../responses/repo-dfse/get-tag-servico-tomado.response';
import { CriarTagServicoTomadoResponse } from '../../responses/repo-dfse/criar-tag-servico-tomado.response';
import { TagSuprimentosRequest } from '../../requests/repo-dfse/tag-suprimentos.request';
import { ServicoTomadoBulkTagRequest } from '../../requests/repo-dfse/servico-tomado-bulk-tag.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class TagServicoTomadoService extends CommonService {
    private readonly apiUrl: string = environment.urlApiRepoDFSe + 'TagServicoTomado';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getAll(descricao: string = '', pagina: number = 1, tamanhoPagina: number = 20): Observable<GetTagServicoTomadoResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (descricao) {
            params = params.set('descricao', descricao);
        }

        return this.httpClient
            .get<GetTagServicoTomadoResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    public getById(id: number): Observable<CriarTagServicoTomadoResponse> {
        const url = `${this.apiUrl}/idTagServicoTomado/${id}`;
        return this.httpClient
            .get<CriarTagServicoTomadoResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public create(request: TagSuprimentosRequest): Observable<CriarTagServicoTomadoResponse> {
        return this.httpClient
            .post<CriarTagServicoTomadoResponse>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: TagSuprimentosRequest): Observable<CriarTagServicoTomadoResponse> {
        const url = `${this.apiUrl}/idTagServicoTomado/${id}`;
        return this.httpClient
            .put<CriarTagServicoTomadoResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public delete(id: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/idTagServicoTomado/${id}`;
        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public deleteBulk(ids: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;
        return this.httpClient
            .post<ReturnStruct>(url, { ids }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Inclui ou remove, em massa, o vínculo de uma ou mais tags em uma ou mais NFS-e de entrada.
     */
    public bulkUpdateVinculos(request: ServicoTomadoBulkTagRequest): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk`;
        return this.httpClient
            .post<ReturnStruct>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
